import React, { useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  GithubAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { setDoc, doc, serverTimestamp } from "firebase/firestore";
import styles from "../styles/Auth.module.css";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // Email/Password Signup
  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const domain = email.split("@")[1];

      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        domain: domain,
        createdAt: serverTimestamp(),
      });

      alert("Account created successfully");
      navigate("/feed");
    } catch (err) {
      alert(err.message);
    }
  };

  const handleProviderSignup = async (Provider) => {
    try {
      const provider = new Provider();
      await signInWithPopup(auth, provider);
      // Note: We might want to create the user doc here too if it doesn't exist
      navigate("/feed");
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.authCard}>
        <h2 className={styles.title}>Join IntraUni</h2>
        <form onSubmit={handleSignup} className={styles.form}>
          <div className={styles.inputGroup}>
            <input
              className={styles.input}
              type="email"
              placeholder="University Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <input
              className={styles.input}
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className={styles.submitBtn}>Sign Up</button>
        </form>

        <div className={styles.divider}>
          <span className={styles.dividerText}>OR</span>
        </div>

        <div className={styles.socialButtons}>
          <button onClick={() => handleProviderSignup(GoogleAuthProvider)} className={styles.socialBtn}>
            Sign up with Google
          </button>
          <button onClick={() => handleProviderSignup(GithubAuthProvider)} className={styles.socialBtn}>
            Sign up with GitHub
          </button>
        </div>

        <div className={styles.switchText}>
          Already have an account?
          <span onClick={() => navigate("/login")} className={styles.switchLink}>
            Log in
          </span>
        </div>
      </div>
    </div>
  );
}